import React from 'react';
import { useState, useEffect, useRef } from 'react';
import Boton from './Boton';

const Botonera = ({ onDesgloseClick, onTraduccionClick, onFuriganaClick, onClickRomaji, onToggleAll,
                    verDesglose, verTraduccion, verFurigana, verRomaji }) => {

    const [showOptions, setShowOptions] = useState(false);
    const [showTutorial, setShowTutorial] = useState(false);
    // Los estados activos ahora vienen como props del componente padre
    // const [activeButtons, setActiveButtons] = useState({
    //     desglose: true,
    //     traduccion: true,
    //     furigana: true,
    //     romaji: true
    // });

    const botoneraRef = useRef(null);

    // Comentado: No necesitamos ejecutar las funciones callback al montar
    // porque los estados ya están correctamente inicializados en el componente padre
    // useEffect(() => {
    //     if (onDesgloseClick) {
    //         onDesgloseClick();
    //     }
    //     if (onTraduccionClick) {
    //         onTraduccionClick();
    //     }
    //     if (onFuriganaClick) {
    //         onFuriganaClick();
    //     }
    //     if (onClickRomaji) {
    //         onClickRomaji();
    //     }
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []); // Solo se ejecuta al montar el componente

    // Cerrar la botonera cuando se hace click fuera de ella
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (botoneraRef.current && !botoneraRef.current.contains(event.target)) {
                setShowOptions(false);
            }
        };

        if (showOptions) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showOptions]);

    const handleButtonClick = (buttonType, originalCallback) => {
        // Ya no necesitamos manejar el estado local, solo ejecutar el callback
        if (originalCallback) {
            originalCallback();
        }
    };

    return (
        <>
            <div ref={botoneraRef} className='mt-12 flex flex-col fixed top-18 right-5 z-50 group'>
                <div className="bg-transparent hover:bg-primary-800/20 backdrop-blur-none hover:backdrop-blur-sm rounded-2xl shadow-lg hover:shadow-2xl border border-transparent hover:border-primary-600/30 overflow-hidden transition-all duration-300 ">
                    <Boton 
                        variant="primary"
                        onClick={() => setShowOptions(!showOptions)}
                        className=""
                    >
                        <span className="flex items-center justify-between transition-opacity duration-300">
                            <span className="flex items-center">
                                ⚙️ <span className="ml-2">オプション</span>
                            </span>
                            <span className={`ml-2 transform transition-transform duration-300 ${showOptions ? 'rotate-180' : 'rotate-0'}`}>
                                ▼
                            </span>
                        </span>
                    </Boton>

                    {showOptions && (
                        <div className="py-2 px-2 space-y-1 animate-in fade-in duration-200 transition-opacity duration-300">
                            {/* Botón para marcar/desmarcar todas las opciones */}
                            <Boton
                                variant="option"
                                isActive={verDesglose && verTraduccion && verFurigana && verRomaji}
                                onClick={() => handleButtonClick('toggleAll', onToggleAll)}
                                className="opacity-30 group-hover:opacity-100 transition-opacity duration-300 border-b border-sage-300 mb-2 pb-2"
                            >
                                <span className="flex items-center">
                                    {verDesglose && verTraduccion && verFurigana && verRomaji 
                                        ? '🔄' : '☑️'} 
                                    <span className="ml-2">
                                        {verDesglose && verTraduccion && verFurigana && verRomaji 
                                            ? 'Desactivar todas' : 'Activar todas'}
                                    </span>
                                </span>
                            </Boton>
                            
                            <Boton
                                variant="option"
                                isActive={verDesglose}
                                onClick={() => handleButtonClick('desglose', onDesgloseClick)}
                                className="opacity-30 group-hover:opacity-100 transition-opacity duration-300"
                            >
                                <span className="flex items-center">
                                    📝 <span className="ml-2">Desglose</span>
                                </span>
                            </Boton>
                            
                            <Boton
                                variant="option"
                                isActive={verTraduccion}
                                onClick={() => handleButtonClick('traduccion', onTraduccionClick)}
                                className="opacity-30 group-hover:opacity-100 transition-opacity duration-300"
                            >
                                <span className="flex items-center">
                                    🌐 <span className="ml-2">Traducción</span>
                                </span>
                            </Boton>
                            
                            <Boton
                                variant="option"
                                isActive={verFurigana}
                                onClick={() => handleButtonClick('furigana', onFuriganaClick)}
                                className="opacity-30 group-hover:opacity-100 transition-opacity duration-300"
                            >
                                <span className="flex items-center">
                                    あ <span className="ml-2">Furigana</span>
                                </span>
                            </Boton>
                            
                            <Boton
                                variant="option"
                                isActive={verRomaji}
                                onClick={() => handleButtonClick('romaji', onClickRomaji)}
                                className="opacity-30 group-hover:opacity-100 transition-opacity duration-300"
                            >
                                <span className="flex items-center">
                                    A <span className="ml-2">Romaji</span>
                                </span>
                            </Boton>
                        </div>
                    )}
                </div>
                
                {/* Botón de ayuda */}
                <div className="mt-2 flex justify-center">
                    <button
                        onClick={() => setShowTutorial(!showTutorial)}
                        className="w-12 h-12 rounded-full flex items-center justify-center bg-gradient-to-br from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 font-bold text-lg border-2 border-white/20"
                    >
                        ?
                    </button>
                </div>
            </div>

            {/* Modal de tutorial */}
            {showTutorial && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                     onClick={() => setShowTutorial(false)}>
                    <div className="bg-white rounded-lg p-6 max-w-md mx-4 shadow-xl cursor-pointer hover:shadow-2xl transition-shadow"
                         onClick={(e) => {
                             e.stopPropagation();
                             setShowTutorial(false);
                         }}>
                        <div className="text-center">
                            <p className="text-lg text-gray-800 mb-4">
                                Haz click sobre un segmento para ver su significado.
                            </p>
                            <p className="text-sm text-gray-600 italic hover:text-gray-800 transition-colors">
                                Presiona para cerrar
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Botonera;